<div class='app-practice-select'
     (click)='modalService.open($event, modalContent, "PRACTICE_SELECT.TITLE")'
     (keydown)='modalService.open($event, modalContent, "PRACTICE_SELECT.TITLE")'>
  <mat-icon class="mat-icon-20 icon"
            svgIcon="practice"></mat-icon>
  <div>
    <p class='text'>{{ firstName }}</p>
    <p class='text last'>{{ lastName }}</p>
  </div>
  <mat-icon class='mat-icon-20 icon'
            svgIcon="keyboard_arrow_down"></mat-icon>
</div>
<ng-template #modalContent>
  <label for='search-bar'
         class='label'>{{ 'PRACTICE_SELECT.LABEL' | translate }}</label>
  <input id='search-bar'
         type='text'
         class='search'
         [placeholder]='"PRACTICE_SELECT.PLACEHOLDER" | translate'
         [formControl]='formControl'>
  <div class='table-scroll'>
    <table>
      <thead>
        <tr>
          <th>
            {{ 'PRACTICE_SELECT.TABLE.COLUMNS.FIRST' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor='let practice of practices'
            (click)='selectPractice(practice)'
            (keydown)='selectPracticeOnKeyDown($event, practice)'>
          <td>{{ parseFirstName(practice, 15) }}
            {{ parseLastName(practice, 15) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
